<template>
    <div class="ChineseRepast">
        <ul class="lists">
            <li v-for="(item,i) in repast_item_name" v-bind:class="{ lists_active: cIndex === i} " @click="clickRepastItem(i)">{{item}}</li>
        </ul>
        <Swiper class="repast_carousel" v-if="repastContent.child[cIndex].images.length > 0"    duration="1000" >
            <Slide v-for="(item,index) in repastContent.child[cIndex].images" :key="index">
                <img :src="weburl+item" alt="" >
            </Slide>
        </Swiper>
        <div class="repastContent">
            <div class="restaurant_name">
                <span class="name">{{repastContent.child[cIndex].name}}</span>
                <br>
                <span class="title">{{$t('name')}}</span>
            </div>
            <p>{{repastContent.child[cIndex].intro}}</p>
        </div>
    </div>
</template>
<script>
import { Swiper, Slide } from "vue-swiper-component";
// import Bus from '../../bus';
export default {
  name: "ChineseRepast",
  components: {
    Swiper,
    Slide
  },
  data: function() {
    return {
      // repast_item:"",         //默认第一家餐厅的数据
      repast_item_name: [], //所有餐厅的名字
      cIndex: 0,
      repastContent: {
        child: [{ images: [] }]
      }
    };
  },
  computed: {
    repast_list: function() {
      return this.$store.state.food.repast_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  },
  created: function() {
    this.$store.commit("set_current", 2);
    this.$store.commit("set_title", "nav.restaurant");
    /* window.addEventListener('beforeunload',()=>{
                var d=JSON.stringify(this.repast_list);
                localStorage.setItem('repast',d);
            });
            var  obj =JSON.parse(localStorage.getItem('repast'));
            this.$store.commit("set_repast_list", this.repast_list?this.repast_list:obj);
            if(this.repast_list==''||this.repast_list==null||this.repast_list==undefined){
                this.repast_item = obj.child[0];
                for (var n = 0;n < obj.child.length;n++){
                    this.repast_item_name.push(obj.child[n].name)
                }
                this.repastContent = obj;

            }else  {
                this.repast_item = this.repast_list.child[0];
                for (var i = 0;i < this.repast_list.child.length;i++){
                    this.repast_item_name.push(this.repast_list.child[i].name)
                }
                this.repastContent = this.repast_list;
            }*/
    this.getRepast(this.$route.query.show_id);
  },
  mounted() {},
  methods: {
    clickRepastItem: function(i) {
      this.cIndex = i;
    },
    getRepast(i) {
      this.$http({
        method: "post",
        url: this.weburl + "/home/Repast/getRepast",
        dataType: "json",
        data: {
          repast_id: i,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              for (var n = 0; n < res.data.result.child.length; n++) {
                this.repast_item_name.push(res.data.result.child[n].name);
              }
              this.repastContent = res.data.result;
            } else {
              this.$toast("没有数据哦");
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/nav.less";
/*轮播图h：220px；*/
.ChineseRepast {
  width: @width;
  .repast_carousel {
    width: @width;
    img {
      width: @width;
      height: calc(100% + 1px);
    }
  }
}
.lists li.lists_active {
  color: @brick_red;
  &:after {
    background: @brick_red;
  }
}
@color: #fcebbd;
.repastContent {
  width: @width;
  min-height: 247px;
  .box-sizing;
  padding: 20px 13%;
  background: url(../../assets/images/repast/repast_5.jpg) no-repeat;
  /*background-size: cover;*/
  @media (max-width: 411px) {
    padding: 30px 13%;
  }

  @media (max-width: 360px) {
    padding: 22px 13%;
  }
  .restaurant_name {
    text-align: center;
    width: @width;
    height: 55px;
    margin-bottom: 10px;
    position: relative;
    &:after,
    &:before {
      content: "";
      top: 0;
      width: 46px;
      height: 100%;
      background: url("../../assets/images/repast/repast_icon.png") no-repeat;
      -webkit-background-size: 46px auto;
      background-size: 46px auto;
    }
    &:after {
      right: 0;
      transform: rotateY(180deg);
    }
    &:before {
      left: 0;
    }
    img {
      display: inline-block;
      width: 80px;
    }
    span {
      display: inline-block;
      color: @color;
    }
    .name {
      font-size: @font + 0.4;
      position: relative;
      padding: 0 12px 6px;
      &:before,
      &:after {
        content: "";
        left: 0;
        width: @width;
        height: 2px;
        border-bottom: 1px dashed @color;
      }
      &:before {
        bottom: 0;
      }
      &:after {
        bottom: -2px;
      }
    }

    .title {
      letter-spacing: 4px;
      font-size: 0.6rem;
      padding-top: 8px;
    }
  }
  p {
    color: @color;
    font-size: 0.9rem;
    text-indent: $font-size * 2;
    line-height: 20px;
  }
}
@media (min-width: 768px) and (orientation: portrait) {
  .repastContent {
    background-size: cover;
    padding: 20px 10%;
    .restaurant_name {
      width: 60%;
      margin: 0 auto 10px;
      height: 70px;
      &:after,
      &:before {
        width: 57px;
        background: url("../../assets/images/repast/repast_icon.png") no-repeat;
        -webkit-background-size: 57px auto;
        background-size: 57px auto;
      }
      &:after {
        right: 0;
        transform: rotateY(180deg);
      }
      &:before {
        left: 0;
      }
      img {
        display: inline-block;
        width: 80px;
      }
      span {
        display: inline-block;
        color: @color;
      }
      .name {
        font-size: @font + 0.8;
        padding: 0 12px 6px;
        &:before,
        &:after {
          content: "";
          left: 0;
          width: @width;
          height: 2px;
          border-bottom: 1px dashed @color;
        }
        &:before {
          bottom: 0;
        }
        &:after {
          bottom: -2px;
        }
      }

      .title {
        font-size: 1.2rem;
      }
    }
    p {
      font-size: 1.2rem;
      line-height: 24px;
    }
  }
}
</style>
